import { APP_BASE_HREF, isPlatformBrowser } from '@angular/common';
import { APP_INITIALIZER, Inject, NgModule, PLATFORM_ID } from '@angular/core';

import { FeatureFlagsService } from '@planone/shared/data-access-feature-flags';
import { KeycloakAngularModule, KeycloakEventType, KeycloakService } from 'keycloak-angular';

import { AppBaseModule } from './app.base.module';
import { AppComponent } from './app.component';

import { environment } from '../environments/environment';

function removeOverlaysBeforeRendering(platformId: string) {
  if (isPlatformBrowser(platformId)) {
    Array.from(document.getElementsByClassName('cdk-overlay-container')).forEach((elem) => {
      elem.remove();
    });
  }
}

function initializeKeycloak(keycloak: KeycloakService, baseHref: string, platformId: string) {
  return () => {
    if (isPlatformBrowser(platformId)) {
      return keycloak
        .init({
          config: {
            url: environment.keycloakUrl,
            realm: 'bau365',
            clientId: environment.keycloakClient,
          },
          initOptions: {
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + (baseHref ?? '/') + 'assets/silent-check-sso.html',
          },
          shouldAddToken: (request) => {
            const urlPattern = new RegExp(
              '^https?:\\/\\/.*(api|auth)\\.(bau365(-(staging|dev))?\\.planone\\.company|bau-insights\\.de).*'
            );
            return urlPattern.test(request.url);
          },
        })
        .then(() => {
          keycloak.keycloakEvents$.subscribe((e) => {
            if (e.type == KeycloakEventType.OnTokenExpired) {
              keycloak.updateToken();
            }
          });
        })
        .catch((e) => {
          console.error('Keycloak init failed');
          console.error(e);
          return null;
        });
    }

    return null;
  };
}

function initializeUnleash(unleash: FeatureFlagsService) {
  return () => {
    unleash.start();
  };
}

@NgModule({
  imports: [AppBaseModule, KeycloakAngularModule],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, APP_BASE_HREF, PLATFORM_ID],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUnleash,
      multi: true,
      deps: [FeatureFlagsService],
    },
  ],
})
export class AppModule {
  constructor(@Inject(PLATFORM_ID) platformId: string) {
    removeOverlaysBeforeRendering(platformId);
  }
}
